import TopBar from "../components/TopBar";
import {
  colors,
  fonts,
  fontSizes,
  headingStyle,
  bodyTextStyle,
  primaryButton,
} from "../theme";

export default function FitnessApp() {
  return (
    <div style={styles.page}>
      <TopBar />
      <div style={styles.shell}>
        <main style={styles.content}>
          <h1 style={styles.h1}>Fitness App (Beta)</h1>
          
          <div style={styles.body}>
            <p style={styles.p}>
              This is a personal fitness app I'm building to support short, equipment-free workouts—especially when time or access to a gym is limited.
            </p>
            <p style={styles.p}>
              It's still evolving, but it's stable enough to use and share.
            </p>
          </div>

          <a
            href="https://prime-sunset-324215.web.app/login"
            target="_blank"
            rel="noreferrer noopener"
            style={styles.button}
          >
            Launch Fitness App
          </a>

          <p style={styles.note}>Beta version · feedback welcome</p>
        </main>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    background: colors.bgPrimary,
    color: colors.textPrimary,
  },

  shell: {
    maxWidth: 900,
    margin: "0 auto",
    padding: "48px 20px",
    fontFamily: fonts.body,
  },

  content: {
    maxWidth: 600,
    margin: "0 auto",
    textAlign: "center",
  },

  h1: {
    ...headingStyle,
    fontSize: fontSizes.h1,
    fontWeight: 700,
    letterSpacing: "-0.01em",
    margin: "0 0 24px 0",
  },

  body: {
    marginBottom: 32,
  },

  p: {
    ...bodyTextStyle,
    margin: "0 0 16px 0",
    opacity: 0.92,
    lineHeight: 1.6,
  },

  button: {
    ...primaryButton,
    display: "inline-block",
    fontWeight: 700,
    textDecoration: "none",
    fontSize: fontSizes.body,
  },

  note: {
    fontFamily: fonts.body,
    fontSize: fontSizes.small,
    opacity: 0.6,
    margin: "16px 0 0 0",
  },
};
